import { Col, Row } from "react-bootstrap"
import styled, { css } from "styled-components"

export const Header = styled.div`
  background: #d2dee2;
  text-align: center;
  padding: 7px 0;
`

export const Lente = styled.button`
  border: 0;
  display: block;
  border: 0;
  width: 60px;
  height: 60px;
  color: #fff;
  padding: 15px;
  border-radius: 5px;
  text-decoration: none;
  background-size: 100%;
  cursor: pointer;
  margin: 0 30%;
  background-image: url(${(props) => props.url});
  @media (max-width: 991.98px) {
    margin: 0 0 0 1%;
  }
`

export const TextHeader = styled.p`
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  height: 40px;
  margin: 0;
  color: #000;
  font-weight: 400;
  font-size: 16px;
  text-align-last: ${(props) => (props.edit ? "end" : "none")};
`

export const IconEdit = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  background-image: url("/images/editar.png");
  background-size: contain;
`

export const IconDelete = styled.a`
  display: block;
  width: 20px;
  height: 20px;
  margin: 0 auto;
  background-image: url("/images/excluir.png");
  background-size: contain;
`

export const Details = styled.div`
  width: 100%;
  padding: 0.7rem;
  background-color: #ffffff;
  line-height: 1.5rem;
  font-size: 16px !important;
`

export const Text = styled.div`
  text-align: center;
  vertical-align: middle !important;
  display: inline-block;
  width: 16%;
`

export const ServiceHeader = styled(Col)`
  background-color: #f4f4f4;
  margin: 16px 0 8px 0;
`

export const Frame = styled(Row)`
  margin: 16px 0 0 0;
  border-top: 2px solid #f4f4f4;
`

export const Description = styled.div`
  text-align: center;
  background-color: #ffffff;
  padding: 5px;
  font-size: 16px;
  .row {
    display: flex;
    align-items: center;
  }
  a {
    color: #2b95ba;
    :hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`
export const ShowDetails = styled.div`
  color: #2b95ba;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`
